import React, { useState, useEffect } from 'react'
import { Drawer, Button, Icon, Spin } from 'antd'
import { safe } from './utils'
import './styles.css'

function DetailsDrawer({ card, visible, onClose }) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  // Reset expanded state when drawer closes
  useEffect(() => {
    if (!visible) {
      setIsExpanded(false)
      setIsLoading(true)
    }
  }, [visible])

  // Reset loading when URL changes
  useEffect(() => {
    if (card && card.jobCardUrl) {
      setIsLoading(true)
    }
  }, [card && card.jobCardUrl])

  if (!card) return null

  const assetLabel = safe(card.assetType || card.assetSubType)
  const locBits = [safe(card.location)]
  if (safe(card.subLocation) !== '—') locBits.push(safe(card.subLocation))

  const jobCardUrl = (card.jobCardUrl || '').trim()
  // console.log('jobCardUrl ', jobCardUrl)

  const title = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: '14px', color: '#172b4d' }}>
          {card.jobCardNo || 'Unknown'} · {safe(card.detailsOfComplaint)}
        </div>
        <div style={{ fontSize: '11px', color: '#6b778c', marginTop: '4px' }}>
          {assetLabel} • {safe(card.assetCode) + '/' + safe(card.altName) + '/' + safe(card.ownerCode)} • {locBits.join(' – ')}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '6px', flexShrink: 0 }}>
        <Button
          type="default"
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            window.open(jobCardUrl, '_blank')
          }}
          title={'Open in new tab'}
          style={{ padding: '4px 4px', height: 'auto', color: '#595959' }}
        >
          <Icon type={'export'} />
        </Button>
        <Button
          type="default"
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            setIsExpanded(prev => !prev)
          }}
          title={isExpanded ? 'Collapse sidebar' : 'Expand to full width'}
          style={{ padding: '4px 4px', height: 'auto', color: '#595959' }}
        >
          <Icon type={isExpanded ? 'shrink' : 'arrows-alt'} />
        </Button>
        <Button
          type="default"
          size="small"
          onClick={onClose}
          title="Close details"
          style={{ padding: '4px 4px', height: 'auto', color: '#595959' }}
        >
          <Icon type="close" />
        </Button>
      </div>
    </div>
  )

  return (
    <Drawer
      title={title}
      placement="right"
      closable={false}
      onClose={onClose}
      visible={visible}
      width={isExpanded ? '100vw' : 500}
      bodyStyle={{ padding: 0, height: '100%', display: 'flex', flexDirection: 'column' }}
      className={isExpanded ? 'drawer-expanded' : 'drawer-collapsed'}
    >
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, position: 'relative' }}>
        {jobCardUrl ? (
          <>
            {isLoading && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                zIndex: 10
              }}>
                <Spin size="large" tip="Loading job card details..." />
              </div>
            )}
            <iframe
              src={jobCardUrl}
              title="Job Card Details"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                flex: 1,
                opacity: isLoading ? 0 : 1,
                transition: 'opacity 0.3s ease'
              }}
              onLoad={() => setIsLoading(false)}
              onError={() => setIsLoading(false)}
            />
          </>
        ) : (
          <div style={{ padding: '24px 16px', textAlign: 'center', color: '#6b778c' }}>
            <p>Job card URL not available.</p>
            <p style={{ fontSize: '12px', marginTop: '8px' }}>Please add "Job Card URL" column to your data.</p>
          </div>
        )}
      </div>
    </Drawer>
  )
}

export default DetailsDrawer

